import React from 'react';
import { motion } from 'framer-motion';
const audiences = [{
  num: '1',
  title: 'Pediatras en Consultorio Privado',
  description: 'Sistematizá tu práctica, blindate legalmente y manejá las situaciones de salud mental con la autoridad que tus pacientes merecen.'
}, {
  num: '2',
  title: 'Pediatras en Hospital Público',
  description: 'Protocolos claros y plantillas listas para usar ante cualquier señal de salud mental o abuso en tu guardia o consultorio.'
}, {
  num: '3',
  title: 'Residentes de Pediatría',
  description: 'Todo lo que necesitás saber sobre salud mental pediátrica desde tu primer turno: clínica, legal y comunicación con padres.'
}, {
  num: '4',
  title: 'Médicos Generalistas que Atienden Niños',
  description: 'El sistema completo para detectar, documentar y derivar correctamente cuando aparece una señal de salud mental en un paciente menor.'
}];
export function Audience() {
  return <section className="bg-white py-8 sm:py-28" data-id="element-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center max-w-3xl mx-auto mb-5 sm:mb-12" data-id="element-18">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-teal-600 uppercase mb-1.5 sm:mb-3" data-id="element-19">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-20">
            Diseñado para vos
          </p>
          <p className="text-xs sm:text-lg text-slate-600" data-id="element-21">
            Si querés atender a tus pacientes con otra cabeza
          </p>
        </div>

        <div className="space-y-2 sm:space-y-3 mb-5 sm:mb-12" data-id="element-22">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} className="flex items-center gap-3 sm:gap-4 p-2.5 sm:p-4 rounded-xl bg-slate-50 ring-1 ring-slate-100" data-id="element-23">
              <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm sm:text-lg font-bold" data-id="element-24">
                {item.num}
              </div>
              <div className="min-w-0" data-id="element-25">
                <h3 className="text-xs sm:text-base font-semibold text-slate-900 leading-snug" data-id="element-26">
                  {item.title}
                </h3>
                <p className="text-[10px] sm:text-sm text-slate-600 leading-snug mt-0.5" data-id="element-27">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-28">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 py-1.5 sm:px-6 sm:py-3 rounded-full bg-slate-100 text-slate-700 text-[10px] sm:text-base font-medium" data-id="element-29">
            <span data-id="element-30">🛡️</span>
            <span data-id="element-31">¿No estás seguro? Tenés 7 días de garantía.</span>
          </div>
        </div>
      </div>
    </section>;
}